
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_297_555)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#748190"}},[_c('path',{attrs:{"d":"M7.827 11.862c-.339-.564-1.268-1.1-2.339-1.1-1.38 0-2.042.578-2.042 1.31 0 .86 1.014 1.1 2.197 1.24 2.057.254 3.972.79 3.972 3.142 0 2.197-1.943 3.141-4.141 3.141-2.014 0-3.564-.62-4.296-2.423l1.55-.803c.436 1.085 1.577 1.564 2.774 1.564 1.17 0 2.268-.409 2.268-1.48 0-.929-.972-1.31-2.282-1.45-2.014-.24-3.874-.775-3.874-2.987 0-2.028 2-2.859 3.818-2.873 1.535 0 3.127.436 3.874 1.958l-1.48.76zM20.715 14.284c.014 1.127-.282 2.296-.915 3.212l1.169 1.155-1.31 1.31-1.198-1.183c-.746.479-1.69.732-2.803.732-3.507 0-5.057-2.55-5.071-5.113-.014-2.578 1.606-5.156 5.071-5.156 3.466 0 5.015 2.508 5.057 5.043zm-8.297.155c.028 1.62 1.1 3.353 3.24 3.353 2.226 0 3.296-1.874 3.226-3.564-.07-1.592-.901-3.31-3.226-3.31-2.324 0-3.268 1.86-3.24 3.521zM23.926 9.48v8.143h5.07v1.718h-6.93v-9.86h1.86z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_297_555"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.606)","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    